// extracted by mini-css-extract-plugin
export default {"container":"Faa-z","productName":"Gaa-z","price":"Haa-z","dimensions":"Iaa-z"};